export const getSearchTerms = (query: string) =>
  query
    .split(" ")
    .filter(Boolean)
    .map((term) => `+${term}`)
    .join(" ");
